module.exports = __webpack_public_path__ + "img/text-input-light-01.a697a94c.png";